import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from './../../services/common.service';
import { UserService } from './../../services/user.service';
import { EncrDecrService } from './../../services/encr-decr.service';
import { ProfessionalService } from './../../services/professional.service';
declare var $: any;


@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.css']
})
export class ViewUserComponent implements OnInit {

  user_id: any = 0;
  company_id: any = 0;
  APIKEY: any = 0;
  editUserForm: FormGroup;
  submitted = false;
  role_list: any = '';
  edit_userid: number = 0;
  SelectedValue: any = ''
  imagePath: any = 'assets/images/users/profile_pic.png';
  dropdownList = [];
  dropdownSettings = {};
  selectedItems: any = {};
  customer_per: any = '';
  notification: any = '';
  customer_list: any = {};

  check_per_mode: boolean = false;
  customer_list_event: boolean = false;
  model = {};
  professional_id: any;
  dropdownList1: any;
  pro_id: any;
  selectedItems1: any;
  dropdownSettings1: { showCheckbox: boolean; singleSelection: boolean; text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean; classes: string; };
  pro_id_not_exist: boolean = false;
  pro_id_check: any;
  professional_id_forTest: any;
  constructor(private formBuilder: FormBuilder,
    private _User: UserService,
    private toastr: ToastrService,
    private EncrDecr: EncrDecrService,
    private _router: Router,
    private _activatedroute: ActivatedRoute,
    private _Common: CommonService, private _professional: ProfessionalService,) { }

  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');

    this.setFormValue();
    this._activatedroute.params.subscribe(params => {
      this.edit_userid = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
    });

    const data = {
      APIKEY: this.APIKEY,
      edit_userid: this.edit_userid,
      company_id: this.company_id,
    }

    this._User.getUserInfoById(data)
      .subscribe(res => {

        res.data.password = this.EncrDecr.get(localStorage.getItem('key'), res.data.password);
        if (res.data.professional_id == '0') {
          // console.log('hi');
          res.data.professional_id = '';
        }

        this.editUserForm.setValue(res.data);

        var role_name = res.data.role;
        var splitrole_name = role_name.split("-", 3);
        if (splitrole_name[1] == 'Professional User') {
          this.customer_list_event = true;

        }
        if (res.data.customer_per == 'all') {
          this.check_per_mode = true;
        }

        if (res.data.profile_pic != '') {
          this.imagePath = res.data.profile_pic;
        }
        else {
          this.imagePath = 'assets/images/users/profile_pic.png';
        }
      });

    this.getRoleList(data);
    this.getCustomerLis(data, 'normal');
    this.dropdownList1 = [];
    this.selectedItems1 = [];
    this.dropdownSettings1 = {
      showCheckbox: false,
      singleSelection: true,
      text: "Select Professional",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: "myclass custom-class"
    };
  }

  onItemSelect(item: any) {
    const datapro = {
      APIKEY: this.APIKEY,
      company_id: this.company_id,
      professional_id: item.id,
    }
    this.pro_id_not_exist = false;
    this.getProfessional_data(datapro);
  }

  getProfessional_data(datapro) {
    this._professional.getprofessionaldata(datapro)
      .subscribe(
        res => {
          // console.log(res.data);
          this.editUserForm.get('email').setValue(res.data.email);
          this.editUserForm.get('phone').setValue(res.data.phone);
          this.editUserForm.get('first_name').setValue(res.data.professional_name);
          if (res.data.status == 'Active') {
            this.editUserForm.get('status').setValue('active');
          } else {
            this.editUserForm.get('status').setValue('inactive');
          }
        },
      );
  }

  onSelectAll(items: any) {
    // console.log(items);
  }

  getCustomerLis(data, mode) {
    this._professional.getProfessionalList(data)
      .subscribe(
        res => {
          if (res.data.professional_id == '0') {
            res.data.professional_id = '';
          }

          var i = 0;
          for (let item of res.data) {
            if (item['id'] == this.edit_userid) {
              this.selectedItems1.push({ 'id': item['item_id'], 'itemName': item['item_text'] });
            }
            if (item['pro_id'] != item['item_id'] || item['id'] == this.edit_userid) {
              this.dropdownList1.push({ 'id': item['item_id'], 'itemName': item['item_text'] });
            }
            i++;
          }
        },
      );
  }
  getRoleList(data) {
    this._Common.getRoleList(data)
      .subscribe(
        res => {
          this.role_list = res.data;
        },
      );
  }

  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => {
        this.imagePath = event.target.result;
      }
      const file = event.target.files[0];
      this.editUserForm.get('profile_pic').setValue(file);
    }
  }

  setFormValue() {
    this.editUserForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: [''],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      country_code: [''],
      phone: [''],
      alter_phone: [''],
      role: ['', Validators.required],
      notification: [''],
      status: [''],
      note: [''],
      customer_per: [''],
      profile_pic: [''],
      id: ['0'],
      professional_id: [''],
    });
  }
  public onChangeRole(event): void {  // event will give you full breif of action
    const newVal = event.target.value;
    var splitted = newVal.split("-", 3);
    var name = splitted[1];
    if (name === 'Professional User') {
      this.customer_list_event = true;
    }
    else {
      this.customer_list_event = false;
    }
  }

  public notify(value) {
    this.model["notification"] = value;
  }

  onlyAlpha_numberic(evt) {
    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //alert(ASCIICode);
    if ((ASCIICode >= 48 && ASCIICode <= 57) || (ASCIICode >= 65 && ASCIICode <= 90) || (ASCIICode >= 97 && ASCIICode <= 122) || ASCIICode == 38 || ASCIICode == 32 || ASCIICode == 39 || ASCIICode == 40 || ASCIICode == 41 || ASCIICode == 45 || ASCIICode == 44 || ASCIICode == 46)
      return true;
    return false;
  }
  onChangeProfessional(pro_id: any) {
    this.professional_id = pro_id;
  }
  check_professional() { }
}
